<template>
  <div class="container plateLayout__container">
    <div class="row plateLayout">
      <div class="plateLayout__title" @click="debug()">
        Panels layout<span class="title__name">: {{slopeFromState.name}}</span>
      </div>
    </div>
    <button class="print unprint" @click="print()">
      <img src="@/assets/img/print-btn.svg" alt="">
    </button>
    <div class="row slopePage__pane plateLayout dragscroll"
         :style="{overflow: isDesktop ? 'hidden' : 'auto'}"
         ref="plateLayout">
      <component
        :is="slopeFromState.slopeForm"
        :slopeParams="slopeFromState.slopeParams"
        :defaultSvgParams="defaultSvgParams"
        :materialAngle="materialAngle"
        :fixtureCalculationThickness="fixtureCalculationThickness"
        :masonryType="masonryType"
        :hKr="hKr"
        :qKr="qKr"
        :y1="y1"
        :y2="y2"
        :isPlate="true"
        :isDetails="true"
        :zoom="zoom"
        :backEndRowsCount="backEndRowsCount"
        ref="svgComponent">
      </component>
      <!--<div class="rtfy" :style="{width: `${defaultSvgParams.width * figureSvgScale}px`,
                          height: `${defaultSvgParams.height * figureSvgScale}px`,
                          transform: `scale(${zoom})`}"
                          v-if="slopeFromState.slopeForm === 'trapezoid'">
        <div class="plates__overlay"
             :style="{marginRight: `${ marginRight }px`, marginBottom: `${marginBottom}px`}">
          <div class="plates">
            <div class="plates__column" v-for="i in columnsCount" :key="i">
              <v-popover
              offset="5"
              placement="left"
              trigger="hover">
              <div class="plates__column-item"
                   :style="{width: `${scale * (slopeFromState.materialSize.width / 1000)}px`,
                            height: `${scale * (slopeFromState.materialSize.height / 1000)}px`}"
                   v-for="n in i % 2 === 0 ? (itemPerColumn + 1) : itemPerColumn" :key="n"></div>
              <div slot="popover" class="popover__row-info">
                 <div class="text">
                   <span class="text__name">Ряд {{ (columnsCount - i) + 1 }} </span>
                   <span class="text__info">
                     <span v-if="slopeFromState.slopeLayersCount > 1">
                     {{ slopeFromState.slopeLayersCount }}</span><span
                     v-if="(((columnsCount - i) + 1) % 2 === 0)">B</span>
                     <span v-else>A</span>
                     <span v-if="(Math.floor(((columnsCount - i) + 2) / 2) - 1) > 0">
                       + <span v-if="Math.floor(((columnsCount - i) + 2) / 2) - 1 > 1">
                       {{Math.floor(((columnsCount - i) + 2) / 2) - 1}}</span>C
                     </span>
                   </span>
                 </div>
                 <div class="img">
                  <span class="img__text">100<br>мм</span>
                   <img src="@/assets/img/brick.svg" alt="brick">
                  <span class="img__text">80<br>мм</span>
                 </div>
              </div>
            </v-popover>
            </div>
          </div>
        </div>
      </div>-->
    </div>
    <div class="zoom__container">
      <input type="range"
             v-model.number="zoom"
             min="1"
             max="10"
             step="1"
             class="similar__box-inputs-range"
             :style="`--min: 1;--max: 10;--val: ${zoom};`"
             ref="inputRange">
      <!--@TODO перевод-->
      <div class="zoom__container-text">scale <b v-if="zoom > 1">x{{zoom}}</b></div>
    </div>
    <PrintTable :materialAngle="materialAngle"
                :fixtureCalculationThickness="fixtureCalculationThickness"
                :masonryType="masonryType"
                :hKr="hKr"
                :qKr="qKr"
                :y1="y1"
                :y2="y2"
                :backEndRowsCount="backEndRowsCount"/>
    <!--<div v-dragscroll="true" class="drag grab-bing">
      <img src="@/assets/img/test.jpg" alt="" :style="{
                          transform: `scale(${zoom})`}">
    </div>-->
  </div>
</template>
<script>

import dragscroll from 'dragscroll/dragscroll.js';
import device from 'current-device';
import Trapezoid from '../figures/Trapezoid.vue';
import Square from '../figures/Square.vue';
import ReverseTrapezoid from '../figures/ReverseTrapezoid.vue';
import CornerLeftTop from '../figures/CornerLeftTop.vue';
import CornerRightTop from '../figures/CornerRightTop.vue';
import CornerLeftBottom from '../figures/CornerLeftBottom.vue';
import CornerRightBottom from '../figures/CornerRightBottom.vue';
import Triangle from '../figures/Triangle.vue';
import DoubleSideTriangleHorizontal from '../figures/DoubleSideTriangleHorizontal.vue';
import DoubleSideTriangleVertical from '../figures/DoubleSideTriangleVertical.vue';
import Rhombus from '../figures/Rhombus.vue';
import RectangularTrapezoidHorizontal from '../figures/RectangularTrapezoidHorizontal.vue';
import RectangularTrapezoidVertical from '../figures/RectangularTrapezoidVertical.vue';
import DoubleSideRectangularTrapezoidVertical
  from '../figures/DoubleSideRectangularTrapezoidVertical.vue';
import PrintTable from '../PrintTable.vue';

export default {
  props: {
    slope: Object,
    materialAngle: Number,
    fixtureCalculationThickness: Number,
    masonryType: String,
    hKr: Number,
    qKr: Number,
    y1: Number,
    y2: Number,
    backEndRowsCount: Number,
  },
  data() {
    return {
      zoom: 1,
      isDesktop: '',
    };
  },
  components: {
    Trapezoid,
    Square,
    ReverseTrapezoid,
    CornerLeftTop,
    CornerRightTop,
    CornerLeftBottom,
    CornerRightBottom,
    Triangle,
    DoubleSideTriangleHorizontal,
    DoubleSideTriangleVertical,
    Rhombus,
    RectangularTrapezoidHorizontal,
    RectangularTrapezoidVertical,
    DoubleSideRectangularTrapezoidVertical,
    PrintTable,
  },
  methods: {
    styleInputRange() {
      document.documentElement.classList.add('js');
      this.$refs.inputRange.addEventListener('input', this.addStyleToRange, false);
    },
    addStyleToRange() {
      this.$refs.inputRange.style.setProperty('--val', +this.$refs.inputRange.value);
    },
    print() {
      window.print();
    },
    debug() {
      // console.log(this.slopeFromState);
      // console.log(JSON.stringify(this.slopeFromState));
    },
  },
  watch: {
    zoom() {
      if (this.zoom > 1) {
        const ratio = 680 / 480;
        const figureWidth = this.$refs.plateLayout.offsetWidth - 48;
        const figureHeight = figureWidth / ratio;
        // console.log(window.screen.width)
        // console.log(figureWidth, figureHeight);
        if (window.screen.width <= 767) {
          this.$refs.plateLayout.scrollTo(((((figureWidth) * this.zoom) / 2) - ((figureWidth) / 2)),
            (((figureHeight * this.zoom) / 2) - (figureHeight / 2)));
        } else {
          this.$refs.plateLayout.scrollTo((((680 * this.zoom) / 2) - (680 / 2)),
            (((480 * this.zoom) / 2) - (480 / 2)));
        }
      }
    },
  },
  mounted() {
    this.styleInputRange();
    dragscroll.reset();
    this.isDesktop = device.desktop();
  },
  computed: {
    slopeFromState() {
      return this.$store.getters.getSlope(this.slopeId);
    },
    slopeId() {
      return (this.$route.params.id) ? this.$route.params.id : 0;
    },
    allSlopes() {
      return this.$store.getters.allSlopes;
    },
    defaultSvgParams() {
      return this.$store.getters.getDafaultSvgParams;
    },
    /* columnsCount() {
      return Math.ceil((this.slopeFromState.slopeParams[0].width * 1000)
                       / this.slopeFromState.materialSize.width);
    },
    itemPerColumn() {
      return (Math.ceil(480 / ((this.slopeFromState.materialSize.height / 1000) * this.scale))) + 1;
    },
    marginRight() {
      return Math.floor((680 - (this.slopeFromState.slopeParams[0].width * this.scale)) / 2);
    },
    indentationToHeight() {
      return ((480 - ((this.slopeFromState.slopeParams[0].height
                   + this.slopeFromState.slopeParams[0].bias1
                   + this.slopeFromState.slopeParams[0].bias2) * this.scale)) / 2)
        + (this.slopeFromState.slopeParams[0].bias2 * this.scale);
    },
    cathet() {
      return ((this.slopeFromState.slopeParams[0].bias2
               * (this.slopeFromState.materialSize.width / 1000))
      / this.slopeFromState.slopeParams[0].width) * this.scale;
    },
    marginBottom() {
      return (((this.indentationToHeight - this.cathet)
      % ((this.slopeFromState.materialSize.height / 1000) * this.scale)) - this.halfPlate)
        - ((this.slopeFromState.materialSize.height / 1000) * this.scale);
    },
    halfPlate() {
      return (this.columnsCount % 2 === 0)
        ? 0 : (((this.slopeFromState.materialSize.height / 1000) / 2) * this.scale);
    },
    figureSvgScale() {
      return this.isNav ? this.defaultSvgParams.navScale : 1;
    },
    scaleH() { // коэффициент высоты
      return ((this.defaultSvgParams.baseHeight * this.figureSvgScale) * 100)
      / (this.slopeFromState.slopeParams[0].height + this.slopeFromState.slopeParams[0].bias1
         + this.slopeFromState.slopeParams[0].bias2);
    },
    scaleW() { // коэффициент ширины
      return ((this.defaultSvgParams.baseWidth * this.figureSvgScale) * 100)
      / this.slopeFromState.slopeParams[0].width;
    },
    scale() { // применяемый коэффициент в зависимости от того какой из коэффициентов больше
      return (this.scaleW > this.scaleH) ? this.scaleH : this.scaleW;
    }, */
  },
};
</script>

<style lang="sass">
.zoom
  &__container
    background: #fff
    display: flex
    flex-direction: row
    align-items: center
    width: rem(280)
    right: rem(32)
    bottom: rem(290)
    transform-origin: right
    border-radius: rem(4)
    justify-content: center
    +media((transform: (320: rotate(0), 576: rotate(-90deg))))
    +media((bottom: (320: unset, 576: rem(290))))
    +media((right: (320: unset, 576: rem(32))))
    +media((position: (320: relative, 576: absolute)))
    +media((padding: (320: rem(10), 576: 0 rem(10))))
    +media((margin: (320: auto, 576: 0)))
    &-text
      font-style: normal
      font-weight: 500
      font-size: rem(12)
      line-height: rem(18)
      color: #999999
      +media((padding-left: (320: rem(20), 576: rem(4))))
      b
        padding-left: rem(4)
.detailsPage
  .plateLayout
    position: relative
    // +media((margin-bottom: (320: 0)))
    &__container
      position: relative
    &__title
      .title__name
        display: none
      @extend .common__title-layout
      +media((padding: (320: rem(43) rem(24) rem(23), 992: rem(36) 0)))
    .figure__wrapper
      margin: auto
      display: block
      // margin-bottom: 300px
      // z-index: 2
      // pointer-events: none
  .print
    position: absolute
    z-index: 2
    display: block
    // margin-bottom: rem(-60)
    background: none
    box-shadow: none
    outline: none
    border: none
    float: right
    padding: rem(10)
    background: #FFFFFF
    right: rem(20)
    cursor: pointer
    +media((top: (320: rem(97), 576: rem(102), 992: rem(121))))
    +media((right: (320: rem(5), 576: rem(10), 992: rem(20))))
  .rtfy
    display: flex
    flex-direction: row
    justify-content: flex-end
    align-items: flex-end
    margin: auto
    // background: lime
    clip-path: url(#figureMask)
    +media((display: (320: none, 768: flex)))
  .plates
    display: flex
    flex-direction: row
    align-items: center
    &__overlay
      // background: #000
    &__column
      line-height: 0
      &:hover
        .plates__column-item
          background: #f7b4b7
          border-color: rgba(227, 7, 19, 0.5)
      &-item
        background: #F6F6F6
        border: rem(1) solid #999999
        transition: .5s
// .popover
  &__row
    &-info
      display: flex
      flex-direction: column
      justify-content: center
      padding: rem(12) rem(28) rem(26)
      .text
        text-align: center
        padding-bottom: rem(15)
        &__name, &__info
          font-style: normal
          font-weight: bold
          font-size: rem(14)
          line-height: rem(18)
        &__name
          color: $black
        &__info
          color: $red
      .img
        display: flex
        flex-direction: row
        align-items: center
        &__text
          font-style: normal
          font-weight: 500
          font-size: rem(12)
          line-height: rem(14)
          color: #5C5C5C
          text-align: center
          min-width: rem(45)
</style>
